"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _default = function _default(a) {
  var b = a.field,
      c = a.hideField,
      d = a.styledComponents,
      e = b.cssClass,
      f = b.width,
      g = b.label,
      h = b.description,
      i = b.descriptionPlacement,
      j = (d || !1).Box,
      k = void 0 === j ? "div" : j;
  return _react["default"].createElement(k, {
    width: f,
    className: "form-field gsection ".concat(e),
    style: {
      display: c ? "none" : void 0
    }
  }, _react["default"].createElement(_react["default"].Fragment, null, "above" === i && h && h && _react["default"].createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: h
    }
  }), _react["default"].createElement("h2", {
    className: "gsection_title",
    dangerouslySetInnerHTML: {
      __html: g
    }
  }), "above" !== i && h && h && _react["default"].createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: h
    }
  })));
};

exports["default"] = _default;